import { Styles } from 'react-jss'

export const sheet: Styles = {
  footer: {
    background: 'linear-gradient(180deg, #081331 0%, #131722 100%)',
    color: '#989FA6'
  },

  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '64px 24px',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(260px, 300px))',
    justifyContent: 'center',
    alignItems: 'start',
    gap: '64px'
  },

  col: {
    fontSize: 18,
    lineHeight: 1.2
  },

  heading: {
    margin: '0 0 24px',
    color: '#FAFAFA',
    fontWeight: 600,
    fontSize: 24,
    whiteSpace: 'nowrap'
  },

  // About
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 12,
    cursor: 'pointer'
  },
  brandTitle: {
    color: '#FFFFFF',
    fontSize: 32,
    fontWeight: 400,
    letterSpacing: '0.02em'
  },
  aboutText: {
    fontSize: 18,
    margin: 0,
    maxWidth: 520
  },

  // Links
  links: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: 24,
    rowGap: 12,

    '& li': {
      marginBottom: 16
    },

    '& a': {
      color: '#989FA6',
      textDecoration: 'none',
      '&:hover': { color: '#d2d6da' }
    }
  },

  // Contact
  contactList: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  mailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: 20,
    '& svg': {
      flex: '0 0 30px'
    },
    '& a': {
      color: '#d2d6da',
      textDecoration: 'none',
      fontSize: 20,
      fontWeight: 300,
      lineHeight: 1.5
    }
  },

  socials: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    gap: 16
  },

  // SVG-icon wrapper
  socialBtn: {
    display: 'inline-flex',
    margin: '0 15px 0 0',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0,
    cursor: 'pointer',
    borderRadius: 9999,
    transition: 'filter .15s ease, transform .08s ease',
    '&:hover': {
      filter: 'brightness(1.5)'
    },
    '&:active': {
      transform: 'translateY(0.5px)'
    },
    '&:focus-visible': {
      outline: '2px solid rgba(40,110,250,.7)',
      outlineOffset: 3,
      borderRadius: 9999
    },
    '& svg': {
      display: 'block'
    }
  },

  // Bottom strip
  divider: {
    height: 1,
    margin: '0 24px',
    background:
      'repeating-linear-gradient(90deg, rgba(255,255,255,0.12), rgba(255,255,255,0.12) 8px, transparent 8px, transparent 16px)'
  },

  bottomRow: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '16px 24px 28px',
    display: 'grid',
    gap: 12,
    justifyItems: 'center',
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 1.2
  },

  copyright: {
    color: '#989FA6'
  },

  disclaimer: {
    color: '#989FA6'
  },

  // Responsive
  '@media (max-width: 1200px)': {
    container: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
      gap: 24
    },
    brandTitle: {
      fontSize: 24
    }
  },
  '@media (max-width: 768px)': {
    container: {
      gridTemplateColumns: '1fr',
      gap: 24
    }
  }
}
